export const environment = {
  production: false,
  apiBaseUrl: '/api/v1',
  siteUrl: 'https://chambia.tgconsulting.online',
  whatsappNumber: '5215500000000',
};
